<template lang="pug">
  .form-user.container.content
    .card: .card-content
      //- Статус
      b-message(:type="value.active ? 'is-success' : 'is-danger'")
        b-switch(v-model="value.active" type="is-success" :true-value="1" :false-value="0")
          | {{ value.active ? 'Документ активен' : 'Документ не активен' }}

      .columns.is-multiline
        .column.is-8-tablet.is-8-desktop
          //- name
          ui-field(label="Название документа" v-model="value.name" :error="errors.name" rules="required")

        .column.is-8-tablet.is-8-desktop
          //- name
          ui-field(type="textarea" label="Описание документа" v-model="value.description" :error="errors.description")

        .column.is-8-tablet.is-8-desktop
          //- category_id
          ui-field(
            type="select"
            v-model="value.category_id"
            :error="errors.category_id"
            label="Категория теста"
          )
            option(:value="0")
            option(v-for="{id, name} in categories.items" :value="id" :key="id") {{ name }}

      .columns.is-multiline
        .column.is-8-tablet.is-8-desktop

          //- file
          b-field(label="Файл (PDF, DOC, DOCX)" :message="errors.file" :type="{'is-danger': errors.file}")
            b-field.mr-10(v-if="value.file && value.file_type")
              b-button(tag="a" :href="value.file")
                b-icon(:type="value.file_type.style" :icon="value.file_type.icon")
                span {{ value.file_original_name }}

            b-field.file.is-primary(:class="{'has-name': !!file}")
              b-upload.file-label(v-model="file" accept=".pdf,.doc,.docx")
                span.file-cta
                  b-icon.file-icon(icon="upload")
                  span.file-label Выбрать файл
                span.file-name(v-if="file") {{ file.name }}

          //- allow_download
          b-field.mt-20(v-if="value.file")
            b-switch(v-model="value.allow_download" :true-value="1" :false-value="0") Разрешено скачивать файл

      b-field(label="Тип документа")
        b-radio-button(v-model="value.type" native-value="file") Файл
        b-radio-button(v-model="value.type" native-value="text") Текст
        b-radio-button(v-model="value.type" native-value="slides") Слайды

      //- .columns.is-multiline(v-if="value.isTypeText")
        .column.is-12-tablet.is-12-desktop
          b-field(label="Содержание документа")
            quill-editor(v-model="value.content")
    .card.mt-20
      .card-header: .card-header-title Доступ
      .card-content
        .columns.is-multiline
          .column.is-4-tablet.is-4-desktop
            b-field(label="Дата начала доступности материала")
              datepicker(v-model="value.start_date")

          .column.is-4-tablet.is-4-desktop
            b-field(label="Дата окончания доступности материала")
              datepicker(v-model="value.end_date")

        b-field
          b-switch(v-model="access_to_all") Доступен всем

        b-field(v-if="!access_to_all")
          b-checkbox.mr-10(v-for="{id, title} in user_groups.items" :value="id" :key="id") {{ title }}
</template>

<script>
import Category from '@/models/Category';
import UserGroup from '@/models/UserGroup';

export default {
  name: 'form-document',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },

  data: () => ({
    file: null,
    categories: Category.collection(),
    user_groups: UserGroup.collection(),
    access_to_all: true,
  }),

  watch: {
    file(file) {
      this.value.file = file;
    },
  },

  computed: {
    // saving() {
    //   return this.value && this.value.$state.saving;
    // },
    // ...mapGetters(['userGroups', 'user']),
    // isSelfEdit() {
    //   return this.value.id === this.user.id;
    // },
  },

  created() {
    this.categories.$fetch();
    this.user_groups.$fetch();
  },
};
</script>
